import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-currency-ex-rates',
  templateUrl: './currency-ex-rates.component.html',
  styleUrls: ['./currency-ex-rates.component.css']
})
export class CurrencyExRatesComponent implements OnInit {
    valutaId;

    currencyTypeKeyno;

    public setting?: Setting;

    public itemsListCurrencyExRates: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.valutaId = this.stateService.getStateParams()['valuta_id'];
        this.currencyTypeKeyno = this.stateService.getStateParams()['currencytype_keyno'];
    }

    private async loadSetting() {
        if (!!this.valutaId && !!this.currencyTypeKeyno) {
            this.setting = (await this.datatask.Post(1021, {
                valuta_id: this.valutaId,
                currencytype_keyno: this.currencyTypeKeyno
            }))[0];
        }
    }

    private async loadCurrencyExRates(): Promise<void> {
        if (!!this.setting) {
            return this.itemsListCurrencyExRates = await this.datatask.Post(1022, this.setting);
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadCurrencyExRates();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    valuta_id: string;
    currencytype_keyno: number;
    currencytype_name: string;
}
